<template>
  <v-container grid-list-md ma-0 class="header-container">
    <v-layout row wrap>
      <v-flex xs12 pa-3 class="header-content text-xs-center white--text headline font-weight-medium">
        Projects
      </v-flex>
      <utility-backButton/>
      <v-flex xs12>
        <!-- Dialog box when edit button is clicked -->
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              Editing Project: {{selectedItem.project.Name}}
              <v-spacer/>
              <v-icon @click="cancelEdit" color="pipefishOrange" medium>mdi-close-circle-outline</v-icon>
            </v-card-title>
            <v-card-text style="padding:2px">
              <v-form ref="form" v-model="validation">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs6 pr-5>
                      <v-text-field
                        label="Project Name"
                        v-model="selectedItem.project.Name"
                        :rules="[!!selectedItem.project.Name || 'Name cannot be empty']"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        :items="displayClients"
                        label="Select a Client"
                        v-model="selectedItem.client"
                        required
                        :rules="[!!selectedItem.client.Name || 'A client needs to be selected']"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        label="Active"
                        v-model="selectedItem.project.IsActive"
                      >
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="pipefishOrange" @click="cancelEdit">Cancel</v-btn>
              <v-btn :loading="showLoading" :disabled="!validation || showLoading" color="pipefishGreen" @click="saveEdit">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Table of projects -->
        
        <v-card-title>
          <!-- <span class="title font-weight-bold"> Projects </span> -->
          <v-spacer></v-spacer>
          <div>
            <v-flex xs12>
              <v-select
                dense
                hide-details
                :items="[{text: 'Active', value: false},
                {text: 'InActive', value: true},
                {text: 'Both', value: 'Both'}]"
                label="Filter on"
                v-model="filterActive"
              >
              </v-select>
            </v-flex>
          </div>
          <div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              hide-details
              color="pipefishGreen"
            >
              <template slot="label">
                <span>Search</span>
              </template>
            </v-text-field>
          </div>
          <v-card-actions>
            <v-spacer/>
            <v-btn  left color="pipefishGreen" @click="addProject">Add</v-btn>
        </v-card-actions>
        </v-card-title> 
        Total Shown: {{projects.length}}
        <v-data-table
          v-if="projects != null"
          :headers="headers"
          :items="projects"
          :search="search"
          sort-icon="mdi-menu-down"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{props.item.project.Name}}</td>
            <td>{{props.item.project.IsActive ? 'active' : 'inactive'}}</td>
            <td>{{props.item.client.Name}}</td>
            <td class="text-xs-right"><utility-editButton @edit="editProject(props.item)"/></td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
    
</template>

<script>
import {
  mapState, mapMutations
} from 'vuex'

export default {
  data: () =>({
    filterActive: false,
    validation: true,
    isEdit: false,
    search: '',
    dialog: false,
    showLoading: false,
    headers: [
      {text: 'Name', value: 'project.Name'},
      {text: 'Active', value: 'project.IsActive', sortable: false},
      {text: 'Client', value: 'client.Name', sortable: false},
      {text:'Action', value:'action',align:'right'}
    ],
    selectedItem: {
      project: {},
      client: {}
    },
    originalItem: {}
  }),
  computed: {
    ...mapState('api', ['timesheetData']),
    projects: function() {
      var allProjectsArray = this.timesheetData.map(client => (client.projects.map(project => ({
        project: project,
        client: client
      }))))
      return allProjectsArray.flat().filter(item => item.project.IsActive != this.filterActive)
    },
    displayClients: function() {
      return this.timesheetData
        .filter(client => client.IsActive)
        .map(client => ({
          text: client.Name,
          value: client
        }))
    }
  },
  created() {
    /* If there is no client,project,activity,etc. data then
     * redirect to /admin so a GET request can be done
     */
    if(this.timesheetData.length == 0) {
      this.$router.push('/admin')
    }
  },
  methods: {
    ...mapMutations('api', ['setTimesheetData']),
    ...mapMutations('admin', ['setProjects']),
    cancelEdit() {
      this.dialog = false
    },
    /**
     * Edit project button is clicked
     */
    editProject(item) {
      this.isEdit = true
      this.showLoading = false
      this.selectedItem.project = Object.assign({}, item.project)
      this.selectedItem.client = Object.assign({}, item.client)
      this.dialog = true
    },
    /**
     * Add project button is clicked
     */
    addProject() {
      this.isEdit = false
      this.showLoading = false
      this.selectedItem.project = {IsActive: false}
      this.selectedItem.client = {}
      this.dialog = true
      this.$refs.form.resetValidation()
    },
    /**
     * Save button is clicked, so save the changes to the project,
     * or create new one if doesn't exist.
     */
    saveEdit() {
      if(!this.$refs.form.validate()) {
        // console.log("contains empty fields")
        return
      }
      var self = this
      this.showLoading = true
      if(this.isEdit) {
        // Editing en exisiting project
        this.$timesheetApi.updateProject(this.selectedItem).then(response => {
          // console.log(response)
          self.$timesheetApi.getData().then(response => {
            self.setTimesheetData(response)
            self.dialog = false
          })
          self.$timesheetApi.getProjects().then(proj => {
            self.setProjects(proj)
          })
        })
      } else {
        // New project is created
        this.$timesheetApi.addProject({
          IsActive: this.selectedItem.project.IsActive,
          Name: this.selectedItem.project.Name,
          ClientId: this.selectedItem.client.id
        }).then(response => {
          self.$timesheetApi.getData().then(response => {
            self.setTimesheetData(response)
            self.dialog = false
          })
          self.$timesheetApi.getProjects().then(proj => {
            self.setProjects(proj)
          })
          self.$refs.form.resetValidation()
        })
      }
    }
  }
}
</script>

<style>
/* .backIcon{
  border: 1px solid white;
  border-radius: 50%;
  background-color: white
} */

</style>
